module.exports = __webpack_public_path__ + "img/icon-secure-payment-ssl.06743662.svg";